import { isBrowser } from './dom';

export function urlCombine(url: URL | string, params: URLSearchParams | Record<string, string>, overwrite = true) {
  if (!isBrowser) return url instanceof URL ? url.href : url;

  const baseUrl = new URL(url, typeof url === 'string' && !url.includes('://') ? window.location.origin : undefined);
  const searchParams = new URLSearchParams(baseUrl.searchParams);

  const fn = overwrite ? searchParams.set : searchParams.append;
  for (const [key, value] of new URLSearchParams(params)) {
    if (key === 'token') continue;
    fn.call(searchParams, key, value);
  }

  baseUrl.search = searchParams.toString();
  return baseUrl.href;
}

export function appendMarketingParams(href: string, params: Record<string, string>) {
  if (!isBrowser || !Object.keys(params).length) return href;

  try {
    const targetUrl = new URL(href, window.location.href);
    if (targetUrl.origin !== window.location.origin) return href;

    Object.entries(params).forEach(([key, value]) => targetUrl.searchParams.set(key, value));
    return targetUrl.href;
  } catch {
    return href;
  }
}

const indexRegexp = /\/(index\/?)?$/gi;

function skipIndex(url: string | undefined) {
  return url?.replace(indexRegexp, '') || '/';
}

export function isCurrentPageLink(href: string | undefined, pathname: string | null) {
  if (!isBrowser || !href || !pathname) return false;

  try {
    const target = new URL(href, window.location.href);
    return target.origin === window.location.origin && skipIndex(target.pathname) === skipIndex(pathname);
  } catch {
    return false;
  }
}
